import { RadioButton, type RadioButtonProps } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { Card, CardSubtitle, CardTitle } from "@progress/kendo-react-layout";
import clsx from "clsx";

import * as styles from "./styles.module.scss";

interface CardRadioButtonProps extends RadioButtonProps {
  name: string;
  description?: string;
  value?: string | boolean | number;
  testId?: string;
}

export const CardRadioButton = ({
  name,
  value,
  checked,
  description,
  label,
  onChange,
  id,
  testId,
}: CardRadioButtonProps) => (
  <Label className={styles.cardRadioButton} editorId={id}>
    <Card
      data-testid={testId ?? `card-${id ?? name}`}
      orientation="horizontal"
      className={clsx(styles.card, checked && styles.card_checked)}
    >
      <RadioButton
        data-testid={`input-${testId ?? id ?? name}`}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
      >
        <div>
          <CardTitle className={styles.marginBottomThin}>{label}</CardTitle>
          {description && (
            <CardSubtitle className={styles.marginBottomThin}>{description}</CardSubtitle>
          )}
        </div>
      </RadioButton>
    </Card>
  </Label>
);
